import { useQuery } from '@apollo/client';
import VRPSTATUS_QUERY from '../queries/VRPSTATUS_QUERY';
import Loading from '../../common/Loading';
import AlertDismissible from '../../common/AlertDismissible';

type VRPStatusT = {
    earnedCY: boolean;
    orderedCY?: string;
    earnedNextCY: boolean;
    orderedNextCY?: string;
};

interface VRPStatusData {
    VRPStatus: VRPStatusT
}

const VRPStatus = ({ chapterId }: { chapterId: string }) => {
    const { data: VRPData, loading, error } = useQuery<VRPStatusData>(VRPSTATUS_QUERY, {
        variables: {
            chapterId
        },
    });
    if (loading) {
        return <Loading />;
    }
    if (error) {
        return <AlertDismissible variant="error">{error.message}</AlertDismissible>
    }
    if (VRPData?.VRPStatus) {
        const status = VRPData.VRPStatus;
        return (
            <>
                <h6>Volunteer Roster Program Incentive</h6>
                <ul>
                    <li>Earned Current CY: <strong>{status.earnedCY ? 'Yes' : 'No'}</strong></li>
                    {status.orderedCY && <li>Ordered for Event: <strong>{status.orderedCY}</strong></li>}
                    <li>Earned Next CY: <strong>{status.earnedNextCY ? 'Yes' : 'No'}</strong></li>
                    {status.orderedNextCY && <li>Ordered for Event: <strong>{status.orderedNextCY}</strong></li>}
                </ul>
            </>
        );
    }
    return null;
};

export default VRPStatus;